import { OngoingMonitoringTypes } from '../types';
import StepPartBlock from '../step-part-block';
import useOngoingMonitoring from './hooks/use-outgoing';
import OngoingMonitoringContent from './parts/content';
import OngoingMonitoringPopups from './parts/popups';

import commonStyles from '../styles.module.css';

const StepFive = ({
  ongoingMonitoring,
  status,
  currentEmployee,
  activePermissions,
  isLoading,
  isAllowed,
  applyError,
  applyWarningInProgress,
  applyOngoingWarning,
  batchApplyWarningInProgress,
  batchApplyOngoingWarning,
  ongoingCheckingStatus,
  restartOngoingCheckingAction,
  restartInProgress,
  onResetTransactionWarningAction,
  resetTransactionsWarningIsLoading,
  resetTransactionsWarningIsSuccess,
  batchApplyWarningIsSuccess,
  selectedWarningId,
  getApplicationWarningsAction,
  paginationInProgress,
  selectedWarningGroup,
  blacklistData,
  setBlacklistData,
  blacklistDataVisible,
  setBlacklistDataVisible,
  blacklistItem,
  setBlacklistDataItem,
  blacklistItemVisible,
  setBlacklistItemVisible,
  getOngoingWarningById,
  isWarningByIdLoading,
  isWarningByIdFetching,
}: OngoingMonitoringTypes) => {
  const ongoingWithoutActions: any[] = [];

  ongoingMonitoring?.forEach((item) => {
    item?.warnings?.edges?.forEach((warning) => {
      if (!warning.node.action) {
        ongoingWithoutActions.push(warning);
      }
    });
  });

  const {
    setApplyAllPopupVisible,
    setComment,
    setMatchStatus,
    setAction,
    onApplyActions,
    comment,
    action,
    matchStatus,
    applyAllPopupVisible,
  } = useOngoingMonitoring({
    batchApplyOngoingWarning,
    batchApplyWarningIsSuccess,
  });

  return (
    <>
      <div className={commonStyles.stepBlockWrapper} style={{ zIndex: 10 }}>
        <div className={commonStyles.stepBlockContent}>
          <StepPartBlock title="Ongoing monitoring" zIndex={10}>
            <OngoingMonitoringContent
              isAllowed={isAllowed}
              isLoading={isLoading}
              status={status}
              ongoingCheckingStatus={ongoingCheckingStatus}
              restartOngoingCheckingAction={restartOngoingCheckingAction}
              restartInProgress={restartInProgress}
              ongoingMonitoring={ongoingMonitoring}
              ongoingWithoutActions={ongoingWithoutActions}
              activePermissions={activePermissions}
              setApplyAllPopupVisible={setApplyAllPopupVisible}
              currentEmployee={currentEmployee}
              applyOngoingWarning={applyOngoingWarning}
              setBlacklistDataVisible={setBlacklistDataVisible}
              setBlacklistItemVisible={setBlacklistItemVisible}
              applyWarningInProgress={applyWarningInProgress}
              setBlacklistData={setBlacklistData}
              setBlacklistDataItem={setBlacklistDataItem}
              onResetTransactionWarningAction={onResetTransactionWarningAction}
              resetTransactionsWarningIsLoading={
                resetTransactionsWarningIsLoading
              }
              resetTransactionsWarningIsSuccess={
                resetTransactionsWarningIsSuccess
              }
              selectedWarningId={selectedWarningId}
              getOngoingWarningById={getOngoingWarningById}
              isWarningByIdFetching={isWarningByIdFetching}
              isWarningByIdLoading={isWarningByIdLoading}
              getApplicationWarningsAction={getApplicationWarningsAction}
              selectedWarningGroup={selectedWarningGroup}
              paginationInProgress={paginationInProgress}
              applyError={applyError}
            />
          </StepPartBlock>
        </div>
      </div>
      <OngoingMonitoringPopups
        setApplyAllPopupVisible={setApplyAllPopupVisible}
        setComment={setComment}
        setMatchStatus={setMatchStatus}
        setAction={setAction}
        onApplyActions={onApplyActions}
        batchApplyWarningInProgress={batchApplyWarningInProgress}
        comment={comment}
        action={action}
        matchStatus={matchStatus}
        applyAllPopupVisible={applyAllPopupVisible}
        ongoingWithoutActions={ongoingWithoutActions}
        activePermissions={activePermissions}
        blacklistDataVisible={blacklistDataVisible}
        setBlacklistDataVisible={setBlacklistDataVisible}
        setBlacklistData={setBlacklistData}
        blacklistData={blacklistData}
        blacklistItemVisible={blacklistItemVisible}
        setBlacklistDataItem={setBlacklistDataItem}
        setBlacklistItemVisible={setBlacklistItemVisible}
        blacklistItem={blacklistItem}
      />
    </>
  );
};

export default StepFive;
